var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReleaseSmallLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73289 10.2605L0.705361 14.2882C0.427318 14.5663 0.427318 15.0171 0.705361 15.2951C0.983404 15.5732 1.4342 15.5732 1.71224 15.2951L5.73977 11.2675C6.01781 10.9894 6.01781 10.5386 5.73977 10.2605C5.46173 9.98249 5.01093 9.98249 4.73289 10.2605Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3159 8.44804L0.503508 10.2605C0.225465 10.5385 0.225465 10.9894 0.503508 11.2674C0.781551 11.5455 1.23235 11.5455 1.51039 11.2674L3.32278 9.45496C3.60082 9.17691 3.60082 8.72609 3.32278 8.44804C3.04473 8.16999 2.59394 8.16999 2.3159 8.44804Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54441 12.6775L4.73202 14.49C4.45398 14.768 4.45398 15.2189 4.73202 15.4969C5.01007 15.775 5.46086 15.775 5.73891 15.4969L7.55129 13.6845C7.82934 13.4064 7.82934 12.9556 7.55129 12.6775C7.27325 12.3995 6.82245 12.3995 6.54441 12.6775Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0613 0.0377686C15.6178 -0.147768 16.1474 0.381773 15.9618 0.938384L11.921 13.0613C11.5419 14.1988 10.0125 14.3871 9.36882 13.3755L6.74607 9.25388L2.6246 6.63104C1.61304 5.98729 1.80131 4.45791 2.93879 4.07874L15.0613 0.0377686Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseSmallLight);
export default __webpack_public_path__ + "static/media/release-small-light.bf6df8f8e948a235dafe6afa043f5c61.svg";
export { ForwardRef as ReactComponent };